import { ResponseErrorConfig } from '@dostavkee/contracts-console/axios-client'
import {
    GetUserBalanceResponse,
    GetUsersProfileBalance400,
} from '@dostavkee/contracts-console/entities'
import {
    GetUsersProfileBalanceQueryKey,
    useGetUsersProfileBalance,
} from '@dostavkee/contracts-console/hooks'
import { QueryObserverOptions } from '@tanstack/react-query'

interface UseBalanceFetchProps {
    query?: Partial<
        QueryObserverOptions<
            GetUserBalanceResponse,
            ResponseErrorConfig<GetUsersProfileBalance400>,
            GetUserBalanceResponse,
            GetUserBalanceResponse,
            GetUsersProfileBalanceQueryKey
        >
    >
}

export const useBalanceFetch = ({ query }: UseBalanceFetchProps = {}) => {
    const { data, isLoading } = useGetUsersProfileBalance({
        query,
    })

    return {
        balance: data,
        isLoading,
        isLoaded: typeof data?.amount === 'number',
    }
}
